import { render, staticRenderFns } from "./VlExaminationTableHeader.vue?vue&type=template&id=e191c9f0&"
import script from "./VlExaminationTableHeader.vue?vue&type=script&lang=js&"
export * from "./VlExaminationTableHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports